<template>
  <div class="wish-list-item--with-delete">
    <WishListItemSkuBasicInformation
      :image-url="imageUrl"
      :brand-name="brandName"
      :item-name="itemName"
      :item-sku-name="itemSkuName"
      :item-id="itemId"
      :item-sku-id="itemSkuId"
      :has-limit="hasLimit"
      :is-sold-out="isSoldOut"
      :wanted-quantity="wantedQuantity"
      :received-quantity="receivedQuantity"
      class="wish-list-item--with-delete__sku-basic-information"
      @click-sku-basic-information="clickSkuBasicInformation"
    />
    <div class="wish-list-item--with-delete__delete-button-area">
      <button
        class="wish-list-item--with-delete__delete-button"
        @click="clickDeleteButton"
      >
        削除
      </button>
    </div>
  </div>
</template>
<script>
import WishListItemSkuBasicInformation from '../../atoms/wish_list/WishListItemSkuBasicInformation.vue'

export default {
  components: {
    WishListItemSkuBasicInformation
  },
  props: {
    userWishListId: {
      type: Number,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    itemSkuId: {
      type: Number,
      required: true
    },
    hasLimit: {
      type: Boolean,
      required: false,
      default: false
    },
    isSoldOut: {
      type: Boolean,
      required: true
    },
    wantedQuantity: {
      type: Number,
      required: false,
      default: 0
    },
    receivedQuantity: {
      type: Number,
      required: false,
      default: 0
    }
  },
  methods: {
    clickSkuBasicInformation() {
      this.$emit(
        'click-sku-basic-information-in-with-delete',
        this.itemId,
        this.itemSkuId
      )
    },
    clickDeleteButton() {
      this.$emit('click-wish-list-item-delete', this.userWishListId)
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-item {
  &--with-delete {
    display: flex;
    max-width: $small-contents-width;
    padding: 16px;
    align-items: center;
    gap: 16px;
    margin: auto;
    border-top: 1px solid $gray-2;

    &__sku-basic-information {
      width: 100%;
      overflow-x: hidden;
      cursor: pointer;
    }

    &__delete-button {
      @extend %minimal;
      color: $black;
      border-radius: 4px;
      background: $gray-2;
      width: 38px;
      height: 26px;
      cursor: pointer;
    }
  }
}
</style>
